export const EXCMCASEPROBLEM_DELETE_RESET = 'EXCMCASEPROBLEM_DELETE_RESET'
export const EXCMCASEPROBLEM_DELETE_SET_ERROR = 'EXCMCASEPROBLEM_DELETE_SET_ERROR'
export const EXCMCASEPROBLEM_DELETE_SET_DELETED = 'EXCMCASEPROBLEM_DELETE_SET_DELETED'
export const EXCMCASEPROBLEM_DELETE_TOGGLE_LOADING = 'EXCMCASEPROBLEM_DELETE_TOGGLE_LOADING'
